import { render, staticRenderFns } from "./AlterarData.vue?vue&type=template&id=a84e9d06&"
import script from "./AlterarData.vue?vue&type=script&lang=js&"
export * from "./AlterarData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports